// opervex-frontend/src/pages/StartTenent.js

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Button, Container, Col, Form, Spinner } from "react-bootstrap";
import MaskedFormControl from "react-bootstrap-maskedinput";
import Opervex from "../Opervex";
import ConfirmService from "../components/ConfirmationModal/ConfirmService";

const StartTenent = () => {
  const [cnpj, setCnpj] = useState("");
  const [validing, setValiding] = useState(false);

  const navigate = useNavigate();

  const handleChangeCnpj = (e) => {
    setCnpj(e.target.value.replace(/[^\d]/g, ""));
  };

  const handleValidateTenant = async () => {
    if (!cnpj) {
      alert("Informe o CNPJ");
      return;
    }

    setValiding(true);

    try {
      const dataTenant = await new Opervex().System.Tenant.findByCNPJ(cnpj);

      if (!dataTenant || dataTenant === "Network Error")
        await ConfirmService.show(
          "Aviso",
          "Erro ao conectar ao sistema de validação de CNPJ, favor entrar em contato com o suporte do sistema",
          true,
        );
      else if (dataTenant?.error) await ConfirmService.show("Aviso", dataTenant.error.message, true);
      else if (!dataTenant?.guid) await ConfirmService.show("Aviso", "Erro ao validar CNPJ", true);
      else
        // Redireciona para login do tenant
        navigate(`/${dataTenant.guid}/Login`);
    } catch (err) {
      await ConfirmService.show("Aviso", "Erro inesperado ao validar tenant", true);
    }

    setValiding(false);
  };

  return (
    <Container fluid className="vh-100 d-flex flex-column">
      <Row className="flex-grow-1 d-flex justify-content-center align-items-center">
        <Col md={6} className="d-flex align-items-center">
          <img
            src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.webp"
            className="img-fluid"
            alt="tenant"
          />
        </Col>

        <Col md={4}>
          <Form className="p-4 border rounded shadow bg-light">
            <h3 className="text-center mb-4">Identificação do Cliente</h3>

            {validing ? (
              <div className="text-center">
                <Spinner animation="border" />
                <br />
                <strong>Validando CNPJ...</strong>
              </div>
            ) : (
              <>
                <Form onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}>
                  <Form.Group className="mb-3">
                    <Form.Label>CNPJ</Form.Label>
                    <MaskedFormControl
                      type="text"
                      size="sm"
                      mask="11.111.111/1111-11"
                      value={cnpj}
                      onChange={handleChangeCnpj}
                      name="cnpj"
                      id="cnpj"
                      autoComplete="on"
                      onKeyUp={(e) => {
                        if (e.key === "Enter") {
                          handleValidateTenant();
                        }
                      }}
                    />
                  </Form.Group>

                  <Button className="w-100" onClick={handleValidateTenant}>
                    Avançar
                  </Button>
                </Form>
              </>
            )}
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default StartTenent;
